import type { ApolloClient } from '@apollo/client';

export const appDefaultOptions: ApolloClient.DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  },
  query: {
    fetchPolicy: 'network-only',
  },
  mutate: {
    refetchQueries: 'active',
    awaitRefetchQueries: true,
  },
};
